// extracted by mini-css-extract-plugin
export var howWeWorkCoverSection = "howWeWorkCover-module--howWeWorkCoverSection--EmvLo";
export var howWeWorkContent = "howWeWorkCover-module--howWeWorkContent--Nj50q";
export var svgWrapper = "howWeWorkCover-module--svgWrapper--R7GkT";